import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  imageCodes,
  titleCodes,
  textCodes,
  videoCodes,
} from "../../template_codes/next/home_page_codes";
import banner from "../../assets/images/next/banner.png";
import Banner from "../../components/fitbae/home/banner";
import Trending from "../../components/fitbae/home/trending";
import FAQ from "../../components/fitbae/home/faq";
import Imagebanner from "../../components/fitbae/home/imagebanner";
import ContactUs from "../../components/fitbae/home/contact";
import SportBra from "../../components/fitbae/home/sport_bra";
import Short from "../../components/fitbae/home/short";
import Legging from "../../components/fitbae/home/legging";
import ScrollSpy from "react-ui-scrollspy";


export default function Home() {
  
  return (
    <div className="overflow-hidden">
      {/*               banner section          */}
      <Banner />
      <Trending title={ 'Trending '} subTitle={"New ARRIVELS"} />
      <FAQ />
      <SportBra title={ "ALL TIME FAVOURITES" } subTitle={"Sports Bra"} />
      <Legging title={ "ALL TIME FAVOURITES" } subTitle={"Leggings"} />
      <Short title={"ALL TIME FAVOURITES"} subTitle={"Shorts"} />
     
          
      <Imagebanner/>
      
     <ContactUs/>
      </div>
  );
}
